import { klevuProductSearch } from "./klevuProductSearch";

export const klevuSearch = async (value, klevuConfig) => {
  const { cloud_search_url, js_api_key } = klevuConfig;
  const body = !value
    ? {
        recordQueries: [
          {
            id: "recsTrending",
            typeOfRequest: "RECS_TRENDING",
            settings: {
              limit: 5,
              typeOfRecords: ["KLEVU_PRODUCT"],
            },
          },
          {
            id: "recsRecentlyViewed",
            typeOfRequest: "SEARCH",
            settings: {
              limit: 1,
            },
          },
        ],
        context: {
          apiKeys: [`${js_api_key}`],
        },
      }
    : {
        recordQueries: [
          {
            id: "productSearch",
            typeOfRequest: "SEARCH",
            settings: {
              query: {
                term: value,
              },
              limit: 5,
              typeOfRecords: ["KLEVU_PRODUCT"],
            },
          },
          {
            id: "categoryProducts",
            typeOfRequest: "RECS_ALSO_VIEWED",
            sort: "NAME_ASC",
            settings: {
              limit: 3,
              query: {
                categoryPath: value,
              },
            },
          },
        ],
        suggestions: [
          {
            id: "mySuggestionsQuery1",
            typeOfQuery: "AUTO_SUGGESTIONS",
            query: value,
            limit: 6,
            hlStartElem: "<span style='font-weight: bold;'>",
            hlEndElem: "</span>",
          },
        ],
        context: {
          apiKeys: [`${js_api_key}`],
        },
      };

  const data = await klevuProductSearch(cloud_search_url, body);
  return data;
};
